import type { TOC } from '@ember/component/template-only';

const ClientsIndexRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default ClientsIndexRouteTemplate;
